// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Button.js with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Button, view, css} from '@sail/ui';

const basic = {
  rendered: (
    <>
      <Button type="primary">Primary</Button>
      <Button>Secondary</Button>
      <Button type="destructive">Destructive</Button>
    </>
  ),
  source: `<Button type="primary">Hello!</Button>
<Button>Secondary</Button>
<Button type="destructive">Destructive</Button>`,
};
const primary = {
  rendered: (
    <Button type="primary" onPress={() => console.log('Button was pressed')}>
      Primary button
    </Button>
  ),
  source: `<Button type="primary" onPress={() => console.log('Button was pressed')}>
  Primary button
</Button>`,
};
const secondary = {
  rendered: (
    <Button onPress={() => console.log('Button was pressed')}>
      Secondary button
    </Button>
  ),
  source: `<Button onPress={() => console.log('Button was pressed')}>
  Secondary button
</Button>`,
};
const destructive = {
  rendered: (
    <Button
      type="destructive"
      onPress={() => console.log('Button was pressed')}
    >
      Destructive button
    </Button>
  ),
  source: `<Button type="destructive" onPress={() => console.log('Button was pressed')}>
  Destructive button
</Button>`,
};
const sizes = {
  rendered: (
    <>
      <Button size="small">Small button</Button>
      <Button>Medium button</Button>
      <Button size="large">Large button</Button>
    </>
  ),
  source: `<Button size="small">Small button</Button>
<Button>Medium button</Button>
<Button size="large">Large button</Button>`,
};
const disabled = {
  rendered: (
    <>
      <Button type="primary" disabled>
        Primary
      </Button>
      <Button disabled>Secondary</Button>
      <Button type="destructive" disabled>
        Destructive
      </Button>
    </>
  ),
  source: `<Button type="primary" disabled>Hello!</Button>
<Button disabled>Secondary</Button>
<Button type="destructive" disabled>Destructive</Button>`,
};
const fullWidth = {
  rendered: (
    <view.div
      css={{
        width: css.value('400px'),
        background: 'surface',
        padding: 'medium',
      }}
    >
      <Button type="primary" css={{width: 'fill', alignX: 'center'}}>
        Full-width button
      </Button>
    </view.div>
  ),
  source: `<Button type="primary" css={{width: 'fill', alignX: 'center'}}>
  Full-width button
</Button>`,
};
export const ButtonExamples = {
  basic,
  primary,
  secondary,
  destructive,
  sizes,
  disabled,
  fullWidth,
};
